import React from 'react'
import { SkeletonButton, SkeletonCard, SkeletonIconText, SkeletonText, SpookySkeleton } from '@offerzen/pinata'
import styles from './styles'

const SkeletonSidebar = () => (
  <SpookySkeleton>
    <SkeletonCard className={styles.card}>
      <div className={styles.header}>
        <SkeletonText theme="dark" width={160} />
      </div>
      <div className={styles.checklistBody}>
        <For each="section" of={[0, 1, 2, 3, 4, 5, 6]}>
          <SkeletonIconText key={`icon-section-${section}`} theme="dark" width={120} size="small" />
        </For>
      </div>
      <div className={styles.footer}>
        <SkeletonButton theme="dark" size="medium" />
      </div>
    </SkeletonCard>
  </SpookySkeleton>
)

export default SkeletonSidebar
